import React, { PureComponent } from 'react';
import { withStyles } from '@material-ui/core/styles';
import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import PropTypes from 'prop-types';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import Divider from '@material-ui/core/Divider';
import Typography from '@material-ui/core/Typography';
import { styles as InputStyles } from '@material-ui/core/Input/Input';
import Button from '@material-ui/core/Button';
import Hidden from '@material-ui/core/Hidden';
import Grid from '@material-ui/core/Grid';
import { Range } from 'rc-slider';
import { omit, merge, pick } from 'ramda';
import 'rc-slider/assets/index.css';

/**
 *
 * Note the code pertaining to small screens is dead code. We have a seperate mobile component
 */
class AdvancedFiltersComp extends PureComponent {
  static propTypes = {
    classes: PropTypes.object,
    filters: PropTypes.object,
    onHoleChange: PropTypes.func,
    onCartChange: PropTypes.func
  };

  handleApply = () => {
    this.props.handleClose()
    this.props.onApplied()
  }

  handleReset = () => {
    this.props.onReset()
    this.props.handleClose()
  }

  render() {
    const { classes, filters, onHoleChange, onCartChange, onTimeChange, onPriceRangeInputChange,  onPriceTextInputChange } = this.props;
    const { timeRange, priceRange, holeCountSelection, golfCartSelection } = filters;
    return (
      <div >
      <Hidden mdUp>
        <Typography variant="title" className={`${classes.padding} ${classes.semiBold}`}>Advanced Filters</Typography>
        <Divider />
      </Hidden>
        <FormControl fullWidth={true} component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={classes.formLabelSliders}>
            <Typography className={`${classes.headers} ${classes.semiBold}`}>Time</Typography>
          </FormLabel>
          <Divider />
          <Range
            trackStyle={[{ backgroundColor: '#53a318', }, { backgroundColor: '#53a318' }]}
            handleStyle={
              [{ height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }, { height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }]
            }
            className={classes.slider}
            min={timeRange.min}
            max={timeRange.max}
            onChange={onTimeChange}
            value={[timeRange.minSelected, timeRange.maxSelected]}
          />
          <Typography className={classes.times}>{`${timeRange.minSelectedFormatted} to ${timeRange.maxSelectedFormatted}`}</Typography>
        </FormControl>
        <br />
        <FormControl fullWidth={true} component="fieldset" className={classes.formControl} >
          <FormLabel component="legend" className={classes.formLabelSliders}>
            <Typography className={`${classes.headers} ${classes.semiBold}`}>Price</Typography>
          </FormLabel>
          <Divider />
          <Range
            trackStyle={[{ backgroundColor: '#53a318', }, { backgroundColor: '#53a318' }]}
            handleStyle={
              [{ height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }, { height: '30px', width: '30px', marginTop: '-13px', boxShadow: '0 1px 4px 0 rgba(0, 0, 0, 0.29)', border: '1px solid #e4e4e4' }]
            }
            className={classes.slider}
            min={priceRange.min}
            max={priceRange.max}
            onChange={onPriceRangeInputChange}
            value={[priceRange.minSelected, priceRange.maxSelected]}
          />
          <Grid container className={classes.priceWrapper}>
          <div className={classes.sliderSymbols} style={{marginRight: '5px'}}><Typography>$</Typography></div>
            <Grid item xs={5} sm={5} className={classes.border}>
              <input className={classes.input} value={priceRange.minTextInput} onChange={event => onPriceTextInputChange('min', event)}/>
            </Grid>
            <Grid item xs={1} sm={1} className={classes.sliderSymbols}><Typography>to</Typography></Grid>
            <Grid item xs={5} sm={5}  className={classes.borderLeft}>
              <input className={classes.input} value={priceRange.maxTextInput} onChange={event => onPriceTextInputChange('max', event)}/>
            </Grid>
          </Grid>
        </FormControl>
        <br />
        <FormControl fullWidth={true} component="fieldset" className={classes.formControl}>
          <FormLabel component="legend" className={classes.formLabel}>
            <Typography className={`${classes.headers} ${classes.semiBold}`}>Holes</Typography>
          </FormLabel>
          <Divider />
          <RadioGroup
            aria-label="holes"
            name="holes"
            className={classes.group}
            onChange={onHoleChange}
            value={holeCountSelection}
          >
            <FormControlLabel className={classes.formControlLabel} value="0" control={<Radio />} label="All" />
            <FormControlLabel className={classes.formControlLabel} value="9" control={<Radio />} label="9" />
            <FormControlLabel className={classes.formControlLabel} value="18" control={<Radio />} label="18" />
          </RadioGroup>
        </FormControl>
        <br />
        <FormControl fullWidth={true} component="fieldset" className={classes.formControl}>
          <FormLabel className={classes.formLabel}>
            <Typography className={`${classes.headers} ${classes.semiBold}`}>Golf Cart</Typography>
          </FormLabel>
          <Divider />
          <RadioGroup
            aria-label="Golf Cart"
            name="golfCart"
            className={classes.group}
            onChange={onCartChange}
            value={golfCartSelection}
          >
            <FormControlLabel value="0"  className={classes.formControlLabel} control={<Radio />} label="All" />
            <FormControlLabel value="1" className={classes.formControlLabel} control={<Radio />} label="Included" />
            <FormControlLabel
              value="2"
              control={<Radio />}
              label="No Golf Cart"
              className={classes.formControlLabel}
            />
          </RadioGroup>
        </FormControl>
        {
          this.props.isDialog ?
            <Grid container className={classes.gridContainer} justify={'center'}>
              <Grid item xs={12}>
                <Grid container justify={'center'} spacing={16}>
                  <Grid item xs={6}>
                    <Button className={classes.reset}  variant="outlined" onClick={this.handleReset} color="primary">
                        Reset
                    </Button>
                  </Grid>
                   <Grid item xs={6}>
                    <Button className={classes.apply}  onClick={this.handleApply} color="primary">
                        Apply
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
          : null
        }
      </div>
    );
  }
}

const styles = theme => {
  /**
   * there is a bug for material - ui controlled Input components that are
   * contained in formcontrol that causes an infinite setState loop when multiple input
   * componets are children for the same formControl component and the value
   * for one of the Input components is an empty string. So I am importing the styles for Input and injecting them into a class for
   * use with native input components.
   */
  const {
    root,
    input
  } = InputStyles(theme);
  const inputStyles = merge(omit(['font', 'color', '&$disabled'], input), pick(['fontSize', 'color', 'fontFamily'], root))
  return ({
    buttonContainer: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    headline: {
      paddingBottom: '10px',
      [theme.breakpoints.down('sm')]: {
        padding: '0 25px 15px',
        fontSize: '14px',
        fontWeight: '600',
        borderBottom: `1px solid #d5d8db`
      }
    },
    headers: {
      fontSize: '16px',
      color: theme.grouponBlack,
    },
    formControl: {
      marginTop: '20px',
      marginBottom: '20px'
    },
    group: {
      margin: `${theme.spacing.unit}px 0`,
      [theme.breakpoints.down('sm')]: {
        padding: '0 20px'
      }
    },
    formLabel: {
      minWidth: '250px',
      paddingBottom: '10px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('sm')]: {
        marginBottom: '10px',
        marginLeft: '20px'
      }
    },
    formLabelSliders: {
      paddingBottom: '6px',
      minWidth: '250px',
      color: theme.palette.common.black,
      [theme.breakpoints.down('sm')]: {
        padding: '20px'
      }
    },
    formControlLabel: {
      maxHeight: '35px'
    },
    border: {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: '2px'
    },
    borderLeft: {
      border: `1px solid ${theme.palette.secondary.light}`,
      borderRadius: '2px'
    },
    slider: {
      margin: '20px 0',
      marginBottom: '16px',
      width: '90%',
      marginLeft: '7px',
      [theme.breakpoints.down('sm')]: {
        margin: '20px 20px',
        padding: '16px',
        width: '80%'
      }
    },
    sliderSymbols: {
      marginTop: '8px',
      textAlign: 'center',
      color: theme.palette.secondary.dark
    },
    times: {
      color: theme.palette.secondary.dark,
      [theme.breakpoints.down('sm')]: {
        marginLeft: '15px',
      }
    },
    dividerHide: {
      [theme.breakpoints.down('sm')]: {
        display: 'none'
      }
    },
    filterIcon: {
      display: 'none',
      [theme.breakpoints.down('sm')]: {
        display: 'inline-flex',
        height: '20px',
        float: 'right'
      }
    },
    priceWrapper: {
      [theme.breakpoints.down('sm')]: {
        padding: '10px',
        paddingRight: '55px'
      }
    },
    reset: {
      [theme.breakpoints.down('sm')]: {
        // padding: '8px 75px',
        width: '100%',
        margin: theme.spacing.unit,
        borderRadius: 0,
        borderColor: theme.palette.primary.main
      }
    },
    apply: {
      [theme.breakpoints.down('sm')]: {
        // padding: '8px 75px',
        width: '100%',
        margin: theme.spacing.unit,
        borderRadius: 0,
        color: theme.palette.common.white,
        backgroundColor: theme.palette.primary.main
      }
    },
    padding: {
      padding: '20px'
    },
    gridContainer: {
      flexGrow: 1,
      padding: '20px',
      paddingRight: '60px'
    },
    semiBold: {
      fontWeight: 600
    },
    input: merge(inputStyles, { padding: '10px'})
  })
};

export default withStyles(styles)(AdvancedFiltersComp);



// WEBPACK FOOTER //
// ./src/components/AdvancedFilters/AdvancedFilter.js